<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="snackbarTimeout"
    :color="snackbarColor"
    top
    right
  >
    {{ text }}
  </v-snackbar>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    timeout: {
      type: Number,
      default: 5000,
    },
    color: {
      type: String,
      default: "info",
    },
  },

  data() {
    return {
      snackbar: true,
      snackbarTimeout: this.timeout || 5000,
      snackbarColor: this.color || "info",
    };
  },
};
</script>
